var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://bgpu.ru/campus-help","target":"_blank","rel":"noreferrer"}},[_c('v-btn',{attrs:{"text":"","color":"primary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-help-circle-outline")]),_vm._v(" Справка ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }